/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./task.vue?vue&type=template&id=6625341a&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=6625341a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625341a",
  null
  
)

export default component.exports